module.exports = __webpack_public_path__ + "resources/img/logo_meetup_color.a31e756a5cbd999e89ff1865d90edecd.png";